import angular from 'angular';
import _ from 'underscore';

import SEGMENT_TRACKING_EVENTS from 'constants/segmentEvents';
import defaultProfilePic from '../../assets/images/placeholder-user.png';

function TeamExternalEditCtrl($scope, $q, $state, $stateParams, $timeout, venueService, sdkUtils, utilsService, managementUserService, alertService, organizationService, organizationRelationshipService, formHelpersService, ERROR_MESSAGES, loggerService, organizationPermissionService, sdkPermissionService, permissionService, TRACKING_EVENT_CATEGORIES, analyticsService) { //eslint-disable-line
  const currentUserOrganization = organizationService.getCurrentOrganization();

  _initScope();

  const promises = [
    _getVenues(),
    _listAllPermissions()
  ];

  if ($scope.editMode) promises.push(_getRelationship());

  $q.all(promises)
    .then(() => {
      if (!$scope.editMode) {
        $scope.relationshipForm = {
          enable: true
        };
      }
    })
    .finally(() => {
      $scope.loading = false;
    });

  function _initScope() {
    $scope.loading = true;
    $scope.relationshipForm = {};
    $scope.relationshipId = $stateParams.id;
    $scope.staffMemberPermissions = [];
    $scope.staffMemberPermissionsByKey = [];
    $scope.editMode = $scope.relationshipId ? true : false; //eslint-disable-line
    $scope.defaultProfilePic = defaultProfilePic;

    $scope.saveRelationship = _saveRelationship;

    $scope.permissionsForm = {
      permissions: []
    };

    $scope.sections = {
      BASIC: 'BASIC',
      PERMISSIONS: 'PERMISSIONS'
    };
    $scope.currentSection = $scope.sections.BASIC;

    $scope.getVenuePermissionTypes = (venueId) => {
      return permissionService.getVenuePromoterPermissionTypes(venueId);
    };
  }

  function _getVenues() {
    return venueService.listByOrganizationId(currentUserOrganization.id, {
        fields: [
          'name',
          'id',
          'nightProId'
        ].join(',')
      })
      .then(venues => {
        return _.filter(venues, venue => {
          return !permissionService.isExternalOrganization(venue.organization);
        });
      })
      .then(venues => {
        $scope.venues = venues;
      })
      .catch(response => alertService.error(sdkUtils.getErrorFromResponse(response)));
  }

  function _getRelationship() {
    return organizationRelationshipService.readByIdAndOrganizationId($scope.relationshipId, currentUserOrganization.id, {
        fields: [
          'childOrganization()'
        ].join(',')
      })
      .then(relationship => {
        $scope.relationship = relationship;

        $scope.relationshipForm = _mapRelationshipDataToForm();

        $scope.staffMemberPermissions = relationship.permissions;

        _mapStaffMemberPermissionsState();
      })
      .catch(response => {
        if (response && response.status !== 404) {
          alertService.error(sdkUtils.getErrorFromResponse(response));
        }
      });
  }

  /**
   * @desc Create or update a relationship
   * @param {Object} form - Angular form object
   * @param {Object} [$event] - Angular event object
   */
  function _saveRelationship(form, $event) {
    if (!form) throw new Error('form is required');
    if ($event) $event.preventDefault();

    $scope.submitted = true;
    $scope.errors = [];

    if (!form.$valid) {
      $scope.errors = formHelpersService.getFormErrors(form);
      return null;
    }

    const relationshipCreateOrUpdateData = _mapChangedFormValuesToApiData(form);

    $scope.savingRelationship = true;

    let createOrUpdateRelationshipPromise;

    // TODO: need to implement updating a relationship in the API
    if ($scope.editMode) {
      const deferred = $q.defer();
      createOrUpdateRelationshipPromise = deferred.promise;
      deferred.resolve($scope.relationship);
    } else {
      createOrUpdateRelationshipPromise = organizationRelationshipService.createByOrganizationId(currentUserOrganization.id, relationshipCreateOrUpdateData);
    }

    return createOrUpdateRelationshipPromise
      .then(relationship => {
        $scope.relationship = relationship;
      })
      .then(_addRemoveStaffMemberPermissions)
      .then(() => {
        if ($scope.editMode) alertService.success('Promoter updated');
        else alertService.success('Promoter created');

        if (!$scope.editMode) {
          _trackPromoterCreated();
        }

        $state.go('app.organization.settings.promoters');
      })
      .catch(response => alertService.error(sdkUtils.getErrorFromResponse(response)))
      .finally(() => {
        $scope.savingRelationship = false;
      });
  }

  /**
   * @desc Maps a hash of values to how the API expects the data to be
   */
  function _mapChangedFormValuesToApiData(form) {
    if (!form) return null;

    let changedValues;

    const relationshipData = {};

    if (!$scope.editMode) {
      changedValues = angular.copy($scope.relationshipForm);
    } else {
      changedValues = formHelpersService.getChangedFormValues(form);
    }

    if ('email' in changedValues) relationshipData.email = changedValues.email;
    if ('name' in changedValues) relationshipData.name = changedValues.name;
    if ('phone' in changedValues) relationshipData.phone = changedValues.phone;
    if ('profileImage' in changedValues) relationshipData.profileImage = changedValues.profileImage;

    return relationshipData;
  }

  /**
   * @desc Maps the $scope.venue to an object the UI will bind to
   * @return Object
   */
  function _mapRelationshipDataToForm() {
    let relationshipEditData = {};

    relationshipEditData = angular.copy($scope.relationship);

    if (relationshipEditData.name) relationshipEditData.name = relationshipEditData.name;
    if (relationshipEditData.phone) relationshipEditData.phone = parseInt(relationshipEditData.phone, 10);

    return relationshipEditData;
  }

  /**
   * @return {Promise}
   */
  function _addRemoveStaffMemberPermissions() {
    const dataPromises = [];

    for (let key in $scope.permissionsForm.permissions) { //eslint-disable-line
      if (key) {
        const promise = _addRemoveStaffMemberPermission(key, $scope.permissionsForm.permissions[key]);

        if (promise) dataPromises.push(promise);
      }
    }

    return $q.all(dataPromises);
  }

  /**
   * @param {String} permissionName
   * @param {Boolean} [add]
   * @return {Promise|null}
   */
  function _addRemoveStaffMemberPermission(permissionName, add) {
    if (!permissionName) throw new Error('teamStaffEditCtrl - _addRemoveStaffMemberPermission() - permissionName is required');

    const comparator = {};

    //TODO Added for IE support replace with _.includes when lodash replaces underscore
    if (permissionName.indexOf('-') >= 0) {
      const parts = permissionName.split('-');

      comparator.venue = parts[0];
      comparator.value = parts[1];
    } else {
      comparator.value = permissionName;
    }

    const existingPermission = _.findWhere($scope.staffMemberPermissions, comparator);
    if (existingPermission && add) return null; //noop since the permission already exists and we're trying to add it again
    else if (!existingPermission && !add) return null;

    const addOrRemovePermissionPromise = existingPermission ?
      organizationPermissionService.deleteByRelationshipIdAndPermissionId($scope.relationshipId, existingPermission.id) :
      organizationPermissionService.createByOrganizationIdAndRelationshipId(currentUserOrganization.id, $scope.relationship.id, {
        venueId: comparator.venue,
        permission: comparator.value
      });

    return addOrRemovePermissionPromise
      .then(permission => {
        if (existingPermission) {
          $scope.staffMemberPermissions.splice($scope.staffMemberPermissions.indexOf(existingPermission), 1);
        } else {
          $scope.staffMemberPermissions.push(permission);
        }
      });
  }

  function _mapStaffMemberPermissionsState() {
    _.each($scope.staffMemberPermissions, staffPermission => { //eslint-disable-line
      const permissionKey = staffPermission.venue ? (`${staffPermission.venue}-${staffPermission.value}`) : staffPermission.value;
      $scope.staffMemberPermissionsByKey[permissionKey] = true;

      console.log('staffMemberPermissionsByKey', $scope.staffMemberPermissionsByKey);

      $scope.permissionsForm.permissions[permissionKey] = true;
    });
  }

  function _listAllPermissions() {
    return sdkPermissionService.list()
      .then(permissions => permissionService.setPermissionTypes(permissions))
      .catch(response => alertService.error(sdkUtils.getErrorFromResponse(response)));
  }

  function _trackPromoterCreated() {
    analyticsService.trackEvent(SEGMENT_TRACKING_EVENTS.CREATED_PROMOTER, {
      category: TRACKING_EVENT_CATEGORIES.PROMOTERS
    });
  }
}

TeamExternalEditCtrl.$inject = [
  '$scope',
  '$q',
  '$state',
  '$stateParams',
  '$timeout',
  'jsSdk.venue',
  'jsSdk.utils',
  'utilsService',
  'jsSdk.managementUser',
  'alertService',
  'organizationService',
  'jsSdk.organizationRelationship',
  'formHelpersService',
  'ERROR_MESSAGES',
  'loggerService',
  'jsSdk.organizationPermission',
  'jsSdk.permission',
  'permissionService',
  'TRACKING_EVENT_CATEGORIES',
  'analyticsService'
];

export default TeamExternalEditCtrl;



// WEBPACK FOOTER //
// ./src/components/teamExternalEdit/teamExternalEditCtrl.js